import React, { cloneElement, Fragment } from "react";
import { useDispatch } from "react-redux";
import { setAnsweringQuestionsAction, checkAnswerAction } from "../../../../redux/answeringQuestions/answeringQuestions";
import { sendNotesLog } from "../../../../api/questionAPI";

const NotEnteredAnswerChecker = ( props ) => {

  const dispatch = useDispatch();
  const setAnsweringQuestions = payload => { dispatch( setAnsweringQuestionsAction( payload ) ) };
  const checkAnswer = () => { dispatch( checkAnswerAction() ) };

  const confirm = () => {
    checkAnswer();
    sendNotesLog();
  };

  const hide = () => {
    setAnsweringQuestions( { isShowNotEnteredAnswerPopup : false } );
  };

  return cloneElement( props.children || <Fragment />, {
    onConfirm : confirm,
    onHide : hide
  } );

};

export default NotEnteredAnswerChecker;
